import { isDev } from "../../wallet_generic/helpers/isDev";

export function getNetworkParameters() {
    if(isDev()) {
        // Rinkeby non esiste più. Mi connetto alla rete reale
        return {
            nome: 'Ethereum Main Net',
            // chainId: '0x4',
            chainId: '0x1',
        };
    } else {
        // Main net
        return {
            nome: 'Ethereum Main Net',
            chainId: '0x1',
        };
    }
}